import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, SubscriptionLike } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { EmailConfigurationService } from 'src/app/services/administration/EmailConfigurationService';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-emailtestconnection',
  templateUrl: './emailtestconnection.component.html',
  styleUrls: ['./emailtestconnection.component.scss']
})
export class EmailtestconnectionComponent implements OnInit {

  @Input() public Content: any;
  smtpForm: UntypedFormGroup;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  action: Subject<any> = new Subject();

  subsmtpTestAsync: SubscriptionLike;
  isGraph: boolean = false;

  constructor(
    private readonly fb: UntypedFormBuilder,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonservice :CommonService,
   // private readonly ngModal: NgbActiveModal,
    //private readonly alertify: AlertifyService,
    private readonly service: EmailConfigurationService
  ) { }

  ngOnDestroy(): void {
    if (this.subsmtpTestAsync)
      this.subsmtpTestAsync.unsubscribe();
  }

  ngOnInit(): void {
    this.buildForm();
    if (this.Content.content.Config != undefined && this.Content.content.Config != null) {
      this.Content.content.Config.ManageAccessToken=this.Content.content.Config.ManageAccessToken==true?1:0;    
      this.smtpForm.get('Config')?.setValue(this.Content.content.Config);
    }

    if (this.Content.content.type == "Graph") {
      this.isGraph = true;
    }
  }

  buildForm() {
    this.smtpForm = this.fb.group({
      ToEmailID:  [null],
      Subject: ['', [Validators.required]],
      Body: [''],
      Config: this.fb.group({
        EmailServerID: [null],
        EmailID: [null, []],
        EmailPwd: [null, []],
        EmailDisplayName: [null, []],
        EmailAccountTypeID: [null, []],
        EmailAccountType: [null, []],
        EmailAccountTypeCode: [null, []],
        TempFileID: [null, []],
        GSuiteFileID: [null, []],
        FileName: [null, []],
        FileExt: [null, []],
        MicrosoftTenantID: [null, []],
        MicrosoftClientID: [null, []],
        MicrosoftClientSecret: [null, []],
        SMTPHost: [null, []],
        SMTPPort: [null, []],
        SMTPSSL: [null, []],
        UserID: [null, []],
        SentItemsFolderName: [null, []],
        IMAPHost: [null, []],
        IMAPPort: [null, []],
        IMAPSSL: [null, []],
        EmailServerStatus: [null, []],
        OrgID: [null, []],
        LoggedUserID: [null, []],
        OrgGroupID: [null, []],
      ManageAccessToken:[false],
      ManageUserEmailID:[null, [Validators.maxLength(100)]],
      ManagerUserPassword:[null, [Validators.maxLength(100)]],
      GraphApiRead:[false],
      GraphApiSend:[false]
      })
    });
  }

  testConn(): void {
    if (this.validateTestForm()) {
      this.subsmtpTestAsync = this.service.smtpTestAsync(this.smtpForm.value).subscribe(
        res => {
          if (res.Status==0){
            this.commonservice.SuccessBanner(res.Message);
            this.modalRef.dismiss();
          }
          else {
            if (res.Message)
      this.commonservice.ValidationBanner(res.Message);

            //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: res.Message } } });   
              //this.alertify.validationBaner(res.errorList);
          }
        },
        err => { 
      this.commonservice.ValidationBanner(err);

          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });  
          //this.alertify.errorBaner(err);
        });
    }
  }

  validateTestForm(): boolean {
    let isValid = true;
    var EmailPattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$");

    var emailto = this.smtpForm.controls['ToEmailID'].value;
    // if (!this.smtpForm.valid ) {
      var err: any = [];
      
      if (emailto==null || emailto=="" || emailto==undefined) {
        err.push("Please enter To </br>");
      }
      if (this.smtpForm.get('Subject')?.errors?.required) {
        err.push("Please enter Subject </br>");
      }

      // if(err.length==0)
      // {
        isValid = true;
        try {
          if (this.smtpForm.controls['ToEmailID'].value) {
     
            if (emailto != null && emailto !="" && emailto != undefined) { var emailtovalid = emailto.replaceAll(",", ";"); }
            var emailtoArr = emailtovalid.split(';');
            for (var i = 0; i < emailtoArr.length; i++) {
              let isvalidemail  =  this.commonservice.validateEmail(emailtoArr[i].trim());
             if (!isvalidemail) {
                err.push("Email ID entered is invalid. Please select another email ID to test the connection</br>");
                break;
              }
            }
          }
        }
        catch (ex) {
  
        }
      //}
     // else{
        if (err && err.length > 0) {  
          let msg=err.join("");
        this.commonservice.ValidationBanner(msg);
  
          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: msg } } });  
          //this.alertify.validationBaner(err);
          isValid = false;
        }
     // }

    //}
    return isValid;
  }

  cancelTestConn(): void {
    //this.ngModal.dismiss('yes');
  //  this.action.next('yes');
    this.modalRef.close('yes');
  }

  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      var emailToValidate = control.value.replaceAll(",", ";");
      var emailToArr = emailToValidate.split(";");
      let valid = true;
      for (var i = 0; i < emailToArr.length; i++) {
        if (!regex.test(emailToArr[i])) {// As per PUBS21R1-I841
          valid = false;
          break;
        }
      }
      return valid ? null : error;
    }
  }

  testGraphConn(): void {
    if (this.validateTestForm()) {
      this.subsmtpTestAsync = this.service.graphSendTestAsync(this.smtpForm.value).subscribe(
        res => {
          if (res.Status == 0) {
            this.commonservice.SuccessBanner(res.Message);
            this.modalRef.dismiss();
          }
          else {
            if (res.Message)
              this.commonservice.ValidationBanner(res.Message);
          }
        },
        err => {
          this.commonservice.ValidationBanner(err);
        });
    }
  }
}
